'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.ListType = void 0;
(function (ListType) {
    ListType["GRID"] = "grid";
    ListType["HORIZONTAL_LIST"] = "horizontalList";
})(exports.ListType || (exports.ListType = {}));
exports.DataSource = void 0;
(function (DataSource) {
    DataSource["APPS"] = "apps";
    DataSource["STATIC"] = "static";
})(exports.DataSource || (exports.DataSource = {}));
exports.CardSize = void 0;
(function (CardSize) {
    CardSize["LARGE"] = "large";
    CardSize["SMALL"] = "small";
})(exports.CardSize || (exports.CardSize = {}));
//# sourceMappingURL=type.js.map
